import { render, staticRenderFns } from "./ompolstring.vue?vue&type=template&id=c2b50464&scoped=true&"
import script from "./ompolstring.vue?vue&type=script&lang=js&"
export * from "./ompolstring.vue?vue&type=script&lang=js&"
import style0 from "./ompolstring.vue?vue&type=style&index=0&id=c2b50464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b50464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c2b50464', component.options)
    } else {
      api.reload('c2b50464', component.options)
    }
    module.hot.accept("./ompolstring.vue?vue&type=template&id=c2b50464&scoped=true&", function () {
      api.rerender('c2b50464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/flow-form/ompolstring.vue"
export default component.exports